module.exports = __webpack_public_path__ + "static/media/fotoNiver.acd9b12f.jpeg";